const baseSteps = [
    {
        target: '[data-tour="for-review-tab"]',
        content: `
        This tab shows all the bank transactions. You can exclude non-purchase transactions.
        Any possible matches will show all purchase activities with the same amount (+- $0.02)
        and similar dates (+- 5 days). Confirm the match or manually find a match.
      `,
        placement: 'bottom',
        disableBeacon: false,
        disableOverlayClose: true,
        hideCloseButton: true,
        styles: {
            options: {
                zIndex: 10000,
            },
        },
    },
    {
        target: '[data-tour="file-upload-tab"]',
        content: 'Click the "File Upload" tab to upload your inventory CSV.',
        placement: 'bottom',
        disableBeacon: false,
        disableOverlayClose: true,
        hideCloseButton: true,
        styles: {
            options: {
                zIndex: 10000,
            },
        },
    },
];

const agentMatchStep = {
    target: '[data-tour="agent-match-button"]',
    content: (
        <div>
            <p>
                Our Agent suggests possible matches based on the last 4 digits of the payment card,
                ticket details, and Order ID from each purchase email. To enable this feature, make
                sure automatic email forwarding is set up.
            </p>
            <div style={{ margin: '15px 0' }}>
                <video
                    width="100%"
                    controls
                    style={{
                        maxWidth: '500px',
                        display: 'block',
                        margin: '0 auto',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    }}
                >
                    <source src="/assets/video/AI-Agent-Matching-Video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            <p>
                For purchases without email data, you can manually review all tickets for an event
                and match them yourself.
            </p>
        </div>
    ),
    placement: 'bottom',
    disableBeacon: false,
    disableOverlayClose: true,
    hideCloseButton: true,
    styles: {
        options: {
            zIndex: 10000,
        },
    },
};

const enhancedBaseSteps = baseSteps.map((step) => ({
    ...step,
    beforeStep: () => {
        const element = document.querySelector(step.target);
        if (!element) {
            console.warn(`Tour target not found: ${step.target}`);
            return false;
        }
        return true;
    },
}));

export const steps = [
    ...enhancedBaseSteps,
    {
        ...agentMatchStep,
        beforeStep: () => {
            const element = document.querySelector(agentMatchStep.target);
            if (!element) {
                console.warn(`Agent match button not found: ${agentMatchStep.target}`);
                return false;
            }
            return true;
        },
    },
];

// Helper function to log when steps are being used
export const getTourSteps = () => {
    return steps;
};

export default getTourSteps;
